export const DEFAULT_LINE_WIDTH = 10
export const DEFAULT_BRUSH_OPACITY = 1
export const DEFAULT_LINE_COLOR = '#FF4444'
export const DEFAULT_RGBA_COLOR = 'rgba(255,68,68,1)'
export const DRAW_CONFIG_NAME = 'drawConfig'
export const VIDEO_CONTROLS_PLACEHOLDER = 70
